import { Injectable } from '@angular/core';
import ProfileJson from '../assets/kb/profiles/profiles.json';

@Injectable({
  providedIn: 'root'
})
export class ProfilesService {

  //profiles supported by RegScale 
  private profiles: any[] = ProfileJson["profiles"];

  constructor() { }

  //returns the list of modules
  getList() {
    return this.profiles;
  }

}
